<template>
  <q-page class="flex flex-center" style="min-height: 100vh">
    <q-card class="login-card q-pa-lg" style="width: 100%; max-width: 420px">
      <q-card-section class="text-center q-mb-md">
        <h4 class="text-oa-gold q-my-none">Olympic Academy</h4>
        <p class="text-oa-secondary q-mt-sm">Inicia sesion en tu cuenta</p>
      </q-card-section>

      <q-card-section>
        <q-banner
          v-if="error"
          class="bg-negative text-white q-mb-md"
          rounded
          dense
        >
          {{ error }}
        </q-banner>

        <q-form @submit.prevent="onSubmit" class="q-gutter-md">
          <q-input
            v-model="email"
            type="email"
            label="Email"
            filled
            :rules="[
              (val: string) => !!val || 'El email es obligatorio',
              (val: string) => /.+@.+\..+/.test(val) || 'Email invalido',
            ]"
            lazy-rules
          >
            <template #prepend>
              <q-icon name="email" />
            </template>
          </q-input>

          <q-input
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            label="Contrasena"
            filled
            :rules="[
              (val: string) => !!val || 'La contrasena es obligatoria',
            ]"
            lazy-rules
          >
            <template #prepend>
              <q-icon name="lock" />
            </template>
            <template #append>
              <q-icon
                :name="showPassword ? 'visibility_off' : 'visibility'"
                class="cursor-pointer"
                @click="showPassword = !showPassword"
              />
            </template>
          </q-input>

          <q-btn
            type="submit"
            label="Iniciar sesion"
            color="primary"
            text-color="white"
            class="full-width q-mt-md"
            size="lg"
            :loading="loading"
            :disable="loading"
            no-caps
          />
        </q-form>
      </q-card-section>

      <q-card-section class="text-center">
        <p class="text-oa-secondary">
          No tenes cuenta?
          <router-link to="/register" class="text-oa-gold" style="text-decoration: none">
            Registrate
          </router-link>
        </p>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useAuthStore } from 'stores/useAuthStore';
import { AxiosError } from 'axios';

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();

const email = ref('');
const password = ref('');
const showPassword = ref(false);
const loading = ref(false);
const error = ref('');

async function onSubmit() {
  error.value = '';
  loading.value = true;

  try {
    await authStore.login(email.value, password.value);
    const redirect = (route.query.redirect as string) || '/';
    await router.push(redirect);
  } catch (err) {
    if (err instanceof AxiosError && err.response?.data?.message) {
      error.value = err.response.data.message as string;
    } else {
      error.value = 'Error al iniciar sesion. Intenta de nuevo.';
    }
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped lang="scss">
.login-card {
  border: 1px solid #333333;
}
</style>
